import { Component } from '@angular/core';
import { BooksService } from '../books.service';
import { Book } from '../book';

@Component({
  selector: 'app-books',
  templateUrl: './books.component.html',
  styleUrls: ['./books.component.css']
})
export class BooksComponent {
  constructor(public bookService: BooksService) { }

  allBooks = this.bookService.allBooks$

  addBook() {
    this.bookService.keepFocus = true
    this.bookService.selectedBook = undefined
    this.bookService.addingNewBook = true
  }

  selectBook(book: Book) {
    this.bookService.addingNewBook = false
    this.bookService.selectedBook = book
  }
}
